module.exports = __webpack_public_path__ + "assets/images/remove-circle-outline.04f9738e202a508c6fdc7ddefeb75ef7.svg";